import RpcService from 'helpers/RpcService';
import RpcTypes from 'constants/rpcTypes';
import { AnyObject } from '../types/Common';
import { Feature } from '../pages/features/types';
import { InternalDomainType } from '../pages/internalDomains/types';

export const getList = (params: AnyObject) => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.InternalDomain_List,
          payload: { ...params },
        },
      ],
      isCancelable: true,
    })
    .then((data) => ({ ...data, items: data.rows || [] }));
};

export const createInternalDomain = async (params: { domain: string }): Promise<any> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.InternalDomain_Create,
        payload: { ...params },
      },
    ],
  });
};

export const updateInternalDomain = async (params: {
  domain: string;
}): Promise<InternalDomainType> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.InternalDomain_Update,
        payload: { ...params },
      },
    ],
  });
};

export const getInternalDomainById = async (
  id: string
): Promise<InternalDomainType> => {
  return new RpcService().request({
    messages: [
      {
        type: RpcTypes.InternalDomain_Get,
        payload: { id },
      },
    ],
    isCancelable: true,
  });
};

export const deleteInternalDomainById = async (id: string,): Promise<any> => {
  return new RpcService()
    .request({
      messages: [
        {
          type: RpcTypes.InternalDomain_Delete,
          payload: { id },
        },
      ],
    });
};


export default {
  getList,
  createInternalDomain,
  updateInternalDomain,
  getInternalDomainById,
  deleteInternalDomainById,
};
